import { useState } from 'react';
import { toast } from 'sonner';
import { supabase, isSupabaseConfigured } from '@/lib/supabase';
import { AuthShell, authInput, authButton } from '@/components/AuthShell';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!isSupabaseConfigured) return;
    // Always send the user back to the configured production app, never localhost.
    const base = process.env.REACT_APP_SITE_URL || window.location.origin;
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${base}/reset-password`,
    });
    if (error) toast.error(error.message);
    else { setSent(true); toast.success('Email de réinitialisation envoyé.'); }
  };

  return (
    <AuthShell title="Mot de passe oublié" subtitle="On t'envoie un lien de réinitialisation.">
      {sent ? (
        <p className="text-sm text-muted-foreground" data-testid="forgot-sent">
          Si un compte existe pour <span className="text-white">{email}</span>, un email vient d'être envoyé.
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={authInput} data-testid="forgot-email" />
          <button type="submit" disabled={!isSupabaseConfigured} className={authButton} data-testid="forgot-submit">Envoyer le lien</button>
        </form>
      )}
    </AuthShell>
  );
}
